import React from "react";
import { Link } from "react-router-dom";


const generateLink = (id, label) => <Link to={id}>{label}</Link>;

export default generateLink;